module.exports = __webpack_public_path__ + "fonts/CeraPro-Black.2ee7ece.ttf";